import React from "react";
import SetupPrompt from "./SetupPrompt";

const Header: React.FC = () => {
  return (
    <header className="w-full">
      <nav
        className="setup-header min-h-[84px] sm:min-h-[104px]"
        aria-label="Main navigation"
      >
        <a
          href="https://tavily.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Tavily home"
          className="brand-link"
        >
          <img
            src="/tavily-by-nebius.svg"
            alt="Tavily, by Nebius"
            className="brand-logo"
          />
        </a>

        <SetupPrompt />

        <div className="nav-actions" aria-hidden="true" />
      </nav>

      <div className="text-center pt-2 pb-2">
        <h1 className="mx-auto max-w-[760px] text-balance">
          Data Enrichment Agent
        </h1>
        {/* Small copy sits on a frosted plate, never directly on the glyph backdrop. */}
        <div
          className="glass mx-auto mt-3 w-fit max-w-[760px] rounded-xl px-5 py-3"
          style={{
            background: "var(--glass)",
            backdropFilter: "blur(28px) saturate(1.3)",
            WebkitBackdropFilter: "blur(28px) saturate(1.3)",
          }}
        >
          <p
            className="text-[15px] font-medium text-balance"
            style={{ color: "var(--color-black)" }}
          >
            Enrich tabular data using Tavily /research
          </p>
          <p
            className="mt-2 text-[14px] leading-[1.6]"
            style={{ color: "var(--ink)" }}
          >
            Best suited for complex and broad questions requiring comprehensive
            analysis.
            <br />
            Each row uses the output_schema to guide search and format results.
          </p>
        </div>
      </div>
    </header>
  );
};

export default Header;
